export const BANQUE_LESSONS = [
  {
    id: 'banque-1',
    numero: 1,
    titre: "Ouvrir un compte bancaire",
    sousTitre: "Documents, démarches, droit au compte",
    contexte: "Marie vient d'arriver en France. Elle doit ouvrir un compte bancaire pour recevoir son salaire mais ne sait pas comment faire.",
    explication: [
      "Pour ouvrir un compte, il faut généralement : **pièce d'identité, justificatif de domicile de moins de 3 mois, et un premier dépôt** (souvent 10 à 50 €).",
      "Vous pouvez ouvrir un compte dans une **banque classique** (Crédit Agricole, BNP…), une **banque en ligne** (Boursorama, Hello Bank…) ou à **La Banque Postale**.",
      "**Tout le monde a droit à un compte bancaire en France** — c'est la loi.",
      "Si une banque refuse votre dossier, vous pouvez exercer votre **droit au compte** : contactez la **Banque de France** qui désignera une banque obligée de vous ouvrir un compte.",
      "La Banque de France : **3414** (numéro gratuit) ou **banque-france.fr**.",
    ],
    question: "Que faire si toutes les banques refusent de vous ouvrir un compte ?",
    options: [
      { id: 'a', text: "Accepter de ne pas avoir de compte", correct: false },
      { id: 'b', text: "Contacter la Banque de France pour exercer son droit au compte", correct: true },
      { id: 'c', text: "Attendre 6 mois et réessayer", correct: false },
    ],
    explication_reponse: "Le droit au compte est garanti par la loi. La Banque de France peut forcer une banque à vous accepter. Appelez le 3414 gratuitement.",
  },
  {
    id: 'banque-2',
    numero: 2,
    titre: "Comprendre son relevé de compte",
    sousTitre: "Lire les opérations, solde, découvert",
    contexte: "Marie reçoit son relevé bancaire par email. Elle ne comprend pas tous les termes et s'inquiète de voir un chiffre négatif.",
    explication: [
      "Le **solde** est le montant disponible sur votre compte à un instant donné. Un chiffre **négatif** signifie que vous êtes à découvert.",
      "Chaque ligne du relevé est une **opération** : débit (argent sorti) ou crédit (argent entré).",
      "Le **découvert autorisé** est une tolérance accordée par la banque — au-delà, des **agios (frais)** s'appliquent.",
      "Les **prélèvements automatiques** (loyer, EDF, abonnements) apparaissent régulièrement — vérifiez qu'ils correspondent à vos contrats.",
      "En cas d'opération inconnue, **signalez-le immédiatement** à votre banque — vous avez **13 mois** pour contester une opération frauduleuse.",
    ],
    question: "Que signifie un solde négatif sur votre relevé ?",
    options: [
      { id: 'a', text: "Vous avez beaucoup d'argent en réserve", correct: false },
      { id: 'b', text: "Vous êtes à découvert — vous devez de l'argent à la banque", correct: true },
      { id: 'c', text: "Votre compte a été piraté", correct: false },
    ],
    explication_reponse: "Un solde négatif indique un découvert. La banque peut appliquer des frais. Renflouez le compte dès que possible pour éviter les agios.",
  },
  {
    id: 'banque-3',
    numero: 3,
    titre: "Gérer son compte en ligne",
    sousTitre: "Application, virement, opposition carte",
    contexte: "Marie veut envoyer de l'argent à sa fille et bloquer sa carte après l'avoir perdue. Elle ne sait pas comment faire depuis son téléphone.",
    explication: [
      "Téléchargez l'**application officielle de votre banque** (vérifiez que c'est bien la vraie sur l'App Store ou Google Play).",
      "Pour faire un **virement** : Menu → Virements → Nouveau → entrez l'IBAN du destinataire, le montant et validez avec votre code.",
      "En cas de perte ou vol de carte : dans l'application, **bloquez la carte immédiatement** (souvent sous 'Mes cartes' → 'Bloquer').",
      "Vous pouvez aussi appeler le **numéro d'opposition universel : 0 892 705 705** (disponible 24h/24, 7j/7).",
      "**Activez les notifications** de votre application pour être alerté à chaque opération — pratique pour détecter les fraudes.",
    ],
    question: "Quel numéro appeler pour faire opposition sur une carte bancaire volée, à toute heure ?",
    options: [
      { id: 'a', text: "Le 15 (SAMU)", correct: false },
      { id: 'b', text: "Le 0 892 705 705", correct: true },
      { id: 'c', text: "Le 3414", correct: false },
    ],
    explication_reponse: "Le 0 892 705 705 est le numéro d'opposition interbancaire, disponible 24h/24. Votre banque a aussi son propre numéro sur votre carte.",
  },
  {
    id: 'banque-4',
    numero: 4,
    titre: "Connaître ses droits bancaires",
    sousTitre: "Frais, plafonds, réclamations",
    contexte: "Marie pense que sa banque lui prélève trop de frais. Elle ne sait pas si c'est normal ni comment réclamer.",
    explication: [
      "Les banques sont obligées de vous donner chaque année un **récapitulatif des frais bancaires** prélevés.",
      "Les **frais d'incidents** (rejet de prélèvement, découvert) sont **plafonnés par la loi** — max 8 € par incident pour les clients fragiles.",
      "Si vous estimez qu'une facturation est abusive, contactez d'abord le **service client** de votre banque par écrit.",
      "En cas de litige non résolu, saisissez le **Médiateur bancaire** (coordonnées sur votre relevé ou site de la banque) — c'est gratuit.",
      "Le site **mesquestionsdargent.fr** (Banque de France) répond gratuitement à toutes vos questions sur vos droits.",
    ],
    question: "Que faire si votre banque refuse de régler un litige sur des frais ?",
    options: [
      { id: 'a', text: "Payer sans discuter", correct: false },
      { id: 'b', text: "Saisir le Médiateur bancaire gratuitement", correct: true },
      { id: 'c', text: "Porter plainte directement au tribunal", correct: false },
    ],
    explication_reponse: "Le Médiateur bancaire est une étape gratuite et obligatoire avant tout recours judiciaire. La banque est tenue de respecter ses recommandations dans la plupart des cas.",
  },
];
